import React, { useEffect, useState } from 'react';
import './index.css'
import { Form, Input, Button, message, Checkbox, Switch } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { UserOutlined, LockOutlined, WechatOutlined, MailOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import request from '@/api'
import { useNavigate } from 'react-router-dom'
import { encryptByDES } from "@/utils/aes";
import logo from "@/assets/logo.png"
import { log } from 'console';

const Login: React.FC = () => {
	const navigate = useNavigate()
	// 登录按钮loading
	const [loading, setLoading] = useState<boolean>(false)
	const tab = ['密码登录', '账号注册']
	const [tabIndex, setTabIndex] = useState<Number>(0)
	const [type1, setType1] = useState<string>('password')
	const [type2, setType2] = useState<string>('password')
	const [type3, setType3] = useState<string>('password')
	// 登录
	const [phone, setPhone] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [verCode, setVerCode] = useState<string>('')
	// 注册
	const [username, setUsername] = useState<string>('')
	const [useremail, setUseremail] = useState<string>('')
	const [registerPassword, setRegisterPassword] = useState<string>('')
	const [confirmPassword, setConfirmPassword] = useState<string>('')
	let regex = /^((0\d{2,3}-\d{7,8})|(1[345678]\d{9}))$/; // 验证手机号
	let regepass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/; // 验证密码
	// 登录
	interface userData { [key: string]: string }
	const loginSumit = async () => {
		const userInfo = { phone, passWord: password, verCode }
		if (phone == '') return message.error('请输入手机号', 0.7)
		if (!regex.test(phone)) return message.error('请输入正确的手机号', 0.7)

		if (password == '') return message.error('请输入密码', 0.7)
		if (!regepass.test(password)) return message.error('密码由6-16个英文和数字组成', 0.7)

		if (verCode == '') return message.error('请输入验证码', 0.7)

		setLoading(true)
		userInfo.passWord = encryptByDES(password) //密码加密
		const res: any = await request.getLogin(userInfo) //登录接口
		setLoading(false)
		if (res?.data?.code == 200) {
			//  存储用户信息 角色信息
			localStorage.setItem('Autn-Token', res.data.token)
			localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
			navigate('/home')
			message.success('登录成功！', 0.3)
		}
	};

	// 注册
	const registerSubmit = async () => {
		if (username == '') return message.error('请输入用户名', 0.7)
		if (useremail == '') return message.error('请输入手机号', 0.7)
		if (!regex.test(useremail)) return message.error('请输入正确的手机号', 0.7)
		if (registerPassword == '') return message.error('请输入密码', 0.7)
		if (!regepass.test(registerPassword)) return message.error('密码由6-16个英文和数字组成', 0.7)
		if (registerPassword != confirmPassword) return message.error('两次输入密码不一致', 0.7)

		let params = {
			userName: username,
			phone: useremail,
			passWord: registerPassword,
		}
		params.passWord = encryptByDES(params.passWord) //密码加密
		const res: any = await request.addUsers(params) //注册接口
		if (res?.data?.code == 200) {
			message.success('注册成功，请登录', 0.3)
			setUsername('')
			setUseremail('')
			setRegisterPassword('')
			setConfirmPassword('')
			setTabIndex(0)
			setPhone(params.phone)
		}
	}
	useEffect(() => {
	});

	return (
		<div className="login">
			<section className="login-content">
				<div className="signQr-leftContainer">
					<div className="Qrcode-container smallVersion">
						<div className="css-k49mnn">打开微信App</div>
						<div className="css-qj3urb">右上角打开扫一扫</div>
						<div className="Qrcode-img">
							<img className="Qrcode-qrcode" width="150" height="150" src="https://p3-juejin.byteimg.com/tos-cn-i-k3u1fbpfcp/c2e3a019d5984d8e8d024704e9904f58~tplv-k3u1fbpfcp-watermark.image" alt="二维码" />
						</div>
						<div className="Qrcode-title">扫描二维码关注后, 点击右下角一键验证获取验证码</div>
					</div>
				</div>
				<div className="passbox">
					<div className="signQr-rightContainer">
						<div className='SignFlow-tabs'>
							{tab.map((item, index) => {
								return (
									<span key={index} onClick={() => { setTabIndex(index) }} className={tabIndex == index ? 'SignFlow-tab--active' : ''}>{item}</span>
								)
							})}
						</div>
						{tabIndex == 0 ?
							<div>
								<div className="SignFlow-account">
									<WechatOutlined />
									<input type="text" className="username-input" placeholder="请输入手机号" value={phone} onChange={e => {
										setPhone(e.target.value);
									}} />
								</div>
								<div className="SignFlow-password">
									<LockOutlined />
									<input type={type1} className="pass-input" placeholder="密码(由6-16个英文和数字组成)" value={password} onChange={e => {
										setPassword(e.target.value);
									}} />
									{type1 == 'password' ? <EyeOutlined onClick={() => { setType1('text') }} /> :
										<EyeInvisibleOutlined onClick={() => { setType1('password') }} />}
								</div>
								<div className="SignFlow-password">
									<MailOutlined />
									<input type="text" className="username-input" placeholder="请输入验证码" value={verCode} onKeyDown={(e) => { if (e.keyCode == 13) loginSumit() }} onChange={e => {
										setVerCode(e.target.value);
									}} />

								</div>
								<div className="Login-options">忘记密码</div>
								<Button type="primary" onClick={loginSumit}>登录</Button>
							</div>
							:
							<div>
								<div className="SignFlow-account">
									<UserOutlined />
									<input type="text" className="username-input" placeholder="请输入用户名" value={username} onChange={e => {
										setUsername(e.target.value);
									}} />
								</div>
								<div className="SignFlow-password">
									<WechatOutlined />
									<input type="text" className="username-input" placeholder="请输入手机号/邮箱" value={useremail} onChange={e => {
										setUseremail(e.target.value);
									}} />
								</div>
								<div className="SignFlow-password">
									<LockOutlined />
									<input type={type2} className="username-input" placeholder="密码(由6-16个英文和数字组成)" value={registerPassword} onChange={e => {
										setRegisterPassword(e.target.value);
									}} />
									{type2 == 'password' ? <EyeOutlined onClick={() => { setType2('text') }} /> :
										<EyeInvisibleOutlined onClick={() => { setType2('password') }} />}
								</div>
								<div className="SignFlow-password">
									<LockOutlined />
									<input type={type3} className="username-input" placeholder="确认密码" value={confirmPassword} onKeyDown={(e) => { if (e.keyCode == 13) registerSubmit() }} onChange={e => {
										setConfirmPassword(e.target.value);
									}} />
									{type3 == 'password' ? <EyeOutlined onClick={() => { setType3('text') }} /> :
										<EyeInvisibleOutlined onClick={() => { setType3('password') }} />}
								</div>
								<Button type="primary" onClick={registerSubmit}>注册</Button>
							</div>
						}
						<div className="SignContainer-tip">
							注册即代表同意
							<span onClick={()=>{navigate('/agreement')}}>《攻城狮协议》</span>
							<span  onClick={()=>{navigate('/privacy')}}>《隐私保护指引》</span></div>
					</div>
				</div>
			</section >

			<Author />
		</div >
	);

}
// https://server01.vicy.cn/8lXdSX7FSMykbl9nFDWESdc6zfouSAEz/wxLogin/tempUserId?secretKey=8fd23bcdd80f491998ae7880a8621f9e
function Author() {
	return (
		<div className="author">
			<div className="ZhihuReports">
				<a target="_blank" rel="noopener noreferrer" href="http://www.12377.cn"
				>网上有害信息举报专区</a
				><a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ts.isc.org.cn/#/home"
				>互联网信息服务投诉平台</a
				><a target="_blank" rel="noopener noreferrer" href="https://110.baidu.com/"
				>反诈中心</a
				><span>违法和不良信息举报：010-82716601</span
				><a href="mailto:18307106535@163.com">侵权举报邮箱：18307106535@163.com</a>
			</div>
			<p>技术支持：<a href="https://jiangsihan.cn/" target="_blank">前端江太公</a> @  江子辰 <a href="mailto:18307106535@163.com"> Send email to ZiChen_Jiang</a> 初始账号及密码：admin 123456</p>
		</div>
	)
}

export default Login
